import type React from "react"
import { Box, Container, Typography, Grid } from "@mui/material"
import FeatureCard from "../molecules/FeatureCard"
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser"
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"

interface Feature {
  icon: React.ReactNode
  title: string
  description: string
}

const features: Feature[] = [
  {
    icon: <VerifiedUserIcon fontSize="large" />,
    title: "Verified Profiles",
    description: "All cooks and maids undergo thorough verification for your safety and peace of mind.",
  },
  {
    icon: <ThumbUpAltIcon fontSize="large" />,
    title: "Quality Assurance",
    description: "We ensure high standards through ratings, reviews, and regular quality checks.",
  },
  {
    icon: <AccessTimeIcon fontSize="large" />,
    title: "Time Saving",
    description: "Save hours of searching and interviewing with our efficient matching system.",
  },
  {
    icon: <SupportAgentIcon fontSize="large" />,
    title: "Dedicated Support",
    description: "Our team is always available to assist you throughout the hiring process.",
  },
]

const WhyChooseUsSection: React.FC = () => {
  return (
    <Box id="why-choose-us" sx={{ py: { xs: 8, md: 12 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h2" component="h2" gutterBottom>
            Why Choose Us
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 700, mx: "auto" }}>
            We combine technology with verified profiles, preferences with flexibility, efficiency with ease, and
            support with excellence—ensuring a seamless hiring experience.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <FeatureCard icon={feature.icon} title={feature.title} description={feature.description} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default WhyChooseUsSection
